<span
  class="section-label-name"
    [ngClass]="{
        alignCenter: alignCenter,
        white: !isTeacher
    }"
  [ngStyle]="{ 'font-size': sectionLabelContent.fontSize }"
  >
  {{ sectionLabelContent.name }}
  @if (sectionLabelContent.icon && !sectionLabelContent.infoTitle) {
    <mat-icon
      class="section-label-icon"
      aria-label="Section Label Icon"
      >{{ sectionLabelContent.icon }}</mat-icon
      >
    }
    @if (sectionLabelContent.icon && sectionLabelContent.infoTitle) {
      <mat-icon
        [matTooltip]="sectionLabelContent.infoContent"
        class="section-label-icon clickable-icon"
        aria-label="Section Label Icon"
        (click)="openGenericDialog()"
        >{{ sectionLabelContent.icon }}</mat-icon
        >
      }
    </span>
    <div
      class="section-label-underline"
      [ngClass]="{ alignCenter: alignCenter }"
    ></div>
